/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Packaging_Material_Tracking_Mode_ColInputs */

const vi_packaging_material_tracking_mode_col = /** @type {(inputs: Packaging_Material_Tracking_Mode_ColInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chế độ`)
};

/**

* @param {Packaging_Material_Tracking_Mode_ColInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const packaging_material_tracking_mode_col = /** @type {((inputs?: Packaging_Material_Tracking_Mode_ColInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Packaging_Material_Tracking_Mode_ColInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_packaging_material_tracking_mode_col(inputs)
});